import React, { createContext, useReducer } from 'react'

export const SET_INLINE_CONNECTION_DATA = 'SET_INLINE_CONNECTION_DATA'
export const UPDATE_CHANGE_INLINE_CONNECTION_DATA =
  'UPDATE_CHANGE_INLINE_CONNECTION_DATA'
export const SET_SELECTED_INLINE_CONNECTION_DATA =
  'SET_SELECTED_INLINE_CONNECTION_DATA'

export const SET_SHOW_HIDE_INLINE_POPUP = 'SET_SHOW_HIDE_INLINE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_INLINE_CONNECTION_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_INLINE_CONNECTION_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: tempData,
        showInlineFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_INLINE_CONNECTION_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showInlineFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_INLINE_POPUP: {
      if (payload.data) {
        return { ...data, showInlineFormPopup: payload.data }
      } else {
        return {
          ...data,
          showInlineFormPopup: payload.data,
          selectedObject: {},
        }
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  showInlineFormPopup: false,
}

const InlineConnectionStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <InlineConnectionContext.Provider value={[state, dispatch]}>
      {children}
    </InlineConnectionContext.Provider>
  )
}

export const InlineConnectionContext = createContext(initialState)
export default InlineConnectionStore
